/**
 * Checks if a user has the required permission
 * @param {Object} user - The user object from auth context
 * @param {string} permission - The permission to check (e.g., 'organization.list')
 * @returns {boolean} - True if user has permission, false otherwise
 */
export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.is_superuser) return true;
  
  // Check direct permissions
  const directPermissions = user.permissions || [];
  if (directPermissions.includes(permission)) return true;
  
  // Check role permissions
  const rolePermissions = user.roles?.flatMap(role => role.permissions || []) || [];
  return rolePermissions.includes(permission);
};

/**
 * Checks if a user has any of the required permissions
 * @param {Object} user - The user object from auth context
 * @param {string[]} permissions - Array of permissions to check
 * @returns {boolean} - True if user has any of the permissions, false otherwise
 */
export const hasAnyPermission = (user, permissions) => {
  if (!user) return false;
  if (user.is_superuser) return true;
  
  // Check direct permissions
  const directPermissions = new Set(user.permissions || []);
  if (permissions.some(perm => directPermissions.has(perm))) return true;
  
  // Check role permissions
  const rolePermissions = new Set(user.roles?.flatMap(role => role.permissions || []) || []);
  return permissions.some(perm => rolePermissions.has(perm));
};
